import React from 'react'
import PropTypes from 'prop-types'

import { Form, Row, Col } from 'react-bootstrap'
import { useForm, useFieldArray, FormProvider } from 'react-hook-form'

import { useCreateUpsell } from './actions'
import OrderAllButton from './OrderAllButton'

const UpsellForm = (props) => {
  const formMethods = useForm({
    defaultValues: {
      items: props.organisations.map((organisation) => {
        return { organisation, selected: props.prechecked }
      }),
    },
  })

  const { formState: { isValidating } } = formMethods

  const createUpsellOrders = useCreateUpsell({
    organisations: props.organisations,
  })

  // Guard submission while validating or posting to API
  // NOTE: we cannot rely on isSubmitting here due to
  // incompatibility between react-hook-form and react-query
  // see: https://github.com/react-hook-form/react-hook-form/issues/9927
  const cannotSubmit = isValidating || createUpsellOrders.isLoading

  const onSubmit = formMethods.handleSubmit(createUpsellOrders.mutate)

  const { fields } = useFieldArray({
    control: formMethods.control,
    name: 'items',
  })

  return (
    <FormProvider {...formMethods}>
      <Form
        onSubmit={onSubmit}
        className='upsell-form align-items-start vstack gap-3 mb-3'
        data-testid='upsell-form'
      >
        <Row className='fieldset-upsell-organisations g-4' xs={2} sm={3} md={4} lg={6}>
          {fields.map(({ id: itemId, organisation }, index) => (
            <Col key={itemId}>
              <Form.Check type='switch' className='p-0 h-100 border'>
                <Form.Check.Label
                  className='vstack align-items-center h-100 justify-content-between'
                  htmlFor={`orga-${organisation.slug}`}
                >
                  <img
                    src={organisation.logo_url}
                    className='img-fluid mb-2 bg-white' alt=''
                  />
                  <span className='text-break mb-2'>{organisation.shortname}</span>
                  <Form.Check.Input
                    type='checkbox' id={`orga-${organisation.slug}`}
                    {...formMethods.register(`items.${index}.selected`)}
                    className='mb-3 mx-0'
                  />
                </Form.Check.Label>
              </Form.Check>
            </Col>
          ))}
        </Row>
        <div className='upsell-form-actions'>
          <button type='submit' className='btn btn-primary' disabled={cannotSubmit}>
            Weiter
          </button>
          <button type='button' onClick={props.onCancel} className='btn btn-link'>
            Abbrechen
          </button>
        </div>
        <p className='privacy-notice'>Es gilt unsere&nbsp;
          <a
            href={`https://www.sprachreisen.org/static/datenschutz`}
            target='_blank'
            rel='noopener noreferrer'
            className='privacy-link'
          >
            Datenschutzerklärung
          </a>
        </p>
      </Form>
    </FormProvider>
  )
}

UpsellForm.propTypes = {
  organisations: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  prechecked: PropTypes.bool.isRequired,
  config: PropTypes.object,
  // How many orders via upsell have been created up to now
//  upsellCount: PropTypes.number.isRequired,
}

export default UpsellForm
